module.exports = __webpack_public_path__ + "img/Ornamen_Bulat_03.1f97d3e9.png";